import React, { createContext, FC, useMemo, useState } from 'react';

import { RequestExceptionWithResponse } from '@eika-infrastruktur/request';

import UserMessageException from '../components/modal/userMessageException';
import { PageOrder } from '../components/page/pageOrder';
import { SoeknadstypeWeb } from '../generated-types';
import ErrorTypes from '../util/gtm/errorTypes';

export interface ErrorExceptionType {
    errorType: ErrorTypes;
    errorException: RequestExceptionWithResponse;
}

export interface AppContextType {
    appNameSpace: string | undefined;
    soeknadstype: SoeknadstypeWeb;
    setSoeknadstype: (soeknadstype: SoeknadstypeWeb) => void;
    error: ErrorExceptionType | undefined;
    setError: (error: ErrorExceptionType) => void;
    pageOrder: string[];
    setPageOrder: (pageOrder: string[]) => void;
}

export const AppContext = createContext<AppContextType>({
    appNameSpace: undefined,
    soeknadstype: SoeknadstypeWeb.UKJENT,
    setSoeknadstype: (soeknadstype) => {
        return soeknadstype;
    },
    error: undefined,
    setError: (error) => {
        return error;
    },
    pageOrder: [],
    setPageOrder: (pageOrder) => {
        return pageOrder;
    },
});

interface Props {
    appName: string;
    soeknadtype: SoeknadstypeWeb;
    children: React.JSX.Element;
    featureToggleUtvideDatagrunnlag?: boolean;
}

const AppContexCoontainer: FC<Props> = ({
    appName,
    soeknadtype,
    children,
    featureToggleUtvideDatagrunnlag = false,
}) => {
    const [appNameSpace] = useState<string>(appName);
    const [soeknadstype, setSoeknadstype] = useState<SoeknadstypeWeb>(soeknadtype);
    const [error, setError] = useState<ErrorExceptionType>();
    const [pageOrder, setPageOrder] = useState<string[]>(PageOrder(soeknadstype, featureToggleUtvideDatagrunnlag));

    const state = useMemo<AppContextType>(
        () => ({
            appNameSpace,
            soeknadstype,
            setSoeknadstype,
            error,
            setError,
            pageOrder,
            setPageOrder,
        }),
        [appNameSpace, soeknadstype, setSoeknadstype, error, setError, pageOrder, setPageOrder],
    );

    return (
        <AppContext.Provider value={state}>
            {error && <UserMessageException error={error} />}
            {children}
        </AppContext.Provider>
    );
};

export default AppContexCoontainer;
